import React, { useState } from 'react';

import Button from 'components/shared/Buttons/Button';

import NewPatientAdminContainer from '../../NewPatientAdminContainer';

const HeaderActions = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <NewPatientAdminContainer
        hideModal={() => {
          setShowModal(false);
        }}
        showModal={showModal}
      />
      <div className="flex items-center gap-2">
        <Button
          text="New Patient"
          icon="add-square-mono"
          size="small"
          transparent
          iconColor="white"
          onClick={() => {
            setShowModal(true);
          }}
          textClassName="whitespace-nowrap"
        />
      </div>
    </>
  );
};

export default HeaderActions;
